import ApiFileService from "../apiFileServices";
import WorkerApiService from "../workerApiServices";


class FileService extends WorkerApiService {

    constructor() {
        super('/api/files')
    }

    upload(file){
        return this.post(`/uploadFile`, file)
    }

    mutipleUpload(data){
        return this.post(`/uploadMultipleFiles`, data)
    }

    // getProgress(key){
    //     return this.get(`/getUploadProgress/${key}`)
    // }

    // deleteProgress(key){
    //     return this.delete(`/deleteProgress/${key}`)
    // }
}

export default FileService